<template>
  <div>
    <v-card>
      <v-toolbar>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Добавить организацию: {{ organisation.orgName }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn @click="save"> <v-icon left>save</v-icon>Записать </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="organisation.orgName"
            label="Полное наименование организации"
            :rules="rules.orgRuleRequired"
            auto-grow
            :error-messages="!organisation.orgName ? ' ' : undefined"
          ></v-text-field>
          <v-text-field
            v-model="organisation.orgShortName"
            label="Сокращенное наименование организации"
            :error-messages="!organisation.orgShortName ? ' ' : undefined"
          ></v-text-field>

          <v-row>
            <v-col cols="6">
              <v-select
                v-model="organisation.pravForm"
                :items="orgPravForm"
                dense
                label="Правовая форма"
                item-text="name"
                item-value="id"
                clearable
                :error-messages="!organisation.pravForm ? ' ' : undefined"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="organisation.nologObl"
                :items="vidnologObl"
                dense
                label="Система налогообложения"
                item-text="name"
                item-value="name"
                clearable
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <template v-if="organisation.pravForm == '2'">
                <v-text-field
                  v-model="organisation.inn"
                  label="ИНН"
                  counter="12"
                  v-mask="'############'"
                  append-outer-icon="mdi-magnify"
                  @click:append-outer="OnChangeINNLupa"
                  :disabled="loading"
                  key="1"
                  :error-messages="!organisation.inn ? ' ' : undefined"
                ></v-text-field>
              </template>
              <template v-else>
                <v-text-field
                  v-model="organisation.inn"
                  counter="10"
                  v-mask="'##########'"
                  append-outer-icon="mdi-magnify"
                  @click:append-outer="OnChangeINNLupa"
                  label="ИНН"
                  key="2"
                  :error-messages="!organisation.inn ? ' ' : undefined"
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="4">
              <template v-if="organisation.pravForm == '2'">
                <v-text-field
                  counter="15"
                  v-mask="'###############'"
                  v-model="organisation.ogrn"
                  label="ОГРНИП"
                  key="4"
                  :error-messages="!organisation.ogrn ? ' ' : undefined"
                ></v-text-field>
              </template>
              <template v-else>
                <v-text-field
                  counter="13"
                  v-mask="'#############'"
                  v-model="organisation.ogrn"
                  label="ОГРН"
                  key="3"
                  :error-messages="!organisation.ogrn ? ' ' : undefined"
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="4">
              <template v-if="organisation.pravForm == '2'">
                <v-text-field
                  counter="9"
                  v-mask="'#########'"
                  v-model="organisation.kpp"
                  label="КПП"
                ></v-text-field>
              </template>
            </v-col>
          </v-row>

          <v-subheader class="subheader1">Руководитель</v-subheader>

          <v-text-field
            v-model="organisation.directorDolgn"
            label="Должность"
          ></v-text-field>

          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="organisation.directorFamil"
                label="Фамилия"
                :error-messages="!organisation.directorFamil ? ' ' : undefined"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="organisation.directorName"
                label="Имя"
                :error-messages="!organisation.directorName ? ' ' : undefined"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="organisation.directorOtch"
                label="Отчество"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="organisation.directorPhone"
                label="Телефон"
                placeholder="(xxx)xxx xx xx"
                prepend-icon="phone"
                v-mask="rules.phonemask"
                prefix="+7"
                :error-messages="!organisation.directorPhone ? ' ' : undefined"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="organisation.directorEmail"
                label="Электронная почта"
                prepend-icon="email"
                placeholder="Email адрес"
                :error-messages="!organisation.directorEmail ? ' ' : undefined"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-subheader class="subheader2">Паспортные данные</v-subheader>
          <v-row>
            <v-col cols="2">
              <v-text-field
                v-model="organisation.directorPassportSer"
                label="Серия"
                v-mask="'####'"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="organisation.directorPassportNumber"
                label="Номер"
                v-mask="'######'"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="organisation.directorPassportVidan"
                label="Кем выдан"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="organisation.directorPassportDataVidachi"
                label="Дата выдачи"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="organisation.directorPassportKodPord"
                label="Код подразделения"
                v-mask="'###-###'"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-subheader class="subheader1">Местонахождение</v-subheader>

          <template v-if="organisation.pravForm == '1'">
            <v-checkbox
              v-model="organisation.jurAddrSovpSFactich"
              label="Адрес регистрации совпадает с фактическим"
            ></v-checkbox>
          </template>
          <v-row>
            <v-col offset="2" cols="8">
              <v-text-field
                v-model="organisation.address"
                label="Адрес из Datata"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col offset="2" cols="4">
              <v-subheader class="subheader2">Юридический адрес</v-subheader>
              <v-text-field
                v-model="organisation.jurAddrIndex"
                label="Индекс"
                v-mask="'######'"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrCountry"
                label="Страна"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrRegion"
                label="Регион"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrRaion"
                label="Район"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrGorIliNasPunkc"
                label="Город / нас. пункт"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrStreet"
                label="Улица"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrDomOficeKvartira"
                label="Дом"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrOfice"
                label="Офис"
              ></v-text-field>
              <v-text-field
                v-model="organisation.jurAddrKvartira"
                label="Квартира"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-subheader class="subheader2">Фактический адрес</v-subheader>
              <v-text-field
                v-model="organisation.factAddrIndex"
                label="Индекс"
                v-mask="'######'"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrCountry"
                label="Страна"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrRegion"
                label="Регион"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrRaion"
                label="Район"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrGorIliNasPunkc"
                label="Город / нас. пункт"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrStreet"
                label="Улица"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrDomOficeKvartira"
                label="Дом"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrOfice"
                label="Офис"
              ></v-text-field>
              <v-text-field
                v-model="organisation.factAddrKvartira"
                label="Квартира"
              ></v-text-field>
            </v-col>
          </v-row>

          <template v-if="organisation.pravForm == '2'">
            <v-checkbox
              v-model="organisation.jurAddrSovpSFactich"
              label="Юр. адрес совпадает с фактическим"
            ></v-checkbox>
          </template>

          <template v-if="organisation.pravForm == '2'">
            <v-row align="center">
              <v-col cols="3">
                <v-subheader>Адрес для получения корреспонденции</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-radio-group v-model="organisation.addrForCorrespondence" row>
                  <v-radio label="Юридический адрес" value="1"></v-radio>
                  <v-radio label="Фактический адрес" value="2"></v-radio>
                  <v-radio label="Иной" value="3"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="organisation.otherAddrIndex"
                  label="Индекс"
                  v-mask="'######'"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrCountry"
                  label="Страна"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrRegion"
                  label="Регион"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrRaion"
                  label="Район"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrGorIliNasPunkc"
                  label="Город / нас. пункт"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrStreet"
                  label="Улица"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrDomOficeKvartira"
                  label="Дом"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrOfice"
                  label="Офис"
                ></v-text-field>
                <v-text-field
                  v-model="organisation.otherAddrKvartira"
                  label="Квартира"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>

          <template v-if="organisation.pravForm == '1'">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="organisation.addrPoluchKorresp"
                  label="Адрес для получения корреспонденции"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Отмена (закрыть)</v-btn>
        <v-btn @click="save">Записать</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Globalrules from "../../components/api/rules.js";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      organisation: {
        orgName: "",
        orgShortName: "",
        pravForm: "1",
        nologObl: "",
        inn: "",
        ogrn: "",
        kpp: "",
        directorDolgn: "",
        directorFamil: "",
        directorName: "",
        directorOtch: "",
        directorPhone: "",
        directorEmail: "",
        directorPassportSer: "",
        directorPassportNumber: "",
        directorPassportVidan: "",
        directorPassportDataVidachi: "",
        directorPassportKodPord: "",
        jurAddrIndex: "",
        jurAddrCountry: "",
        jurAddrRegion: "",
        jurAddrRaion: "",
        jurAddrGorIliNasPunkc: "",
        jurAddrStreet: "",
        jurAddrDomOficeKvartira: "",
        jurAddrOfice: "",
        jurAddrKvartira: "",
        factAddrIndex: "",
        factAddrCountry: "",
        factAddrRegion: "",
        factAddrRaion: "",
        factAddrGorIliNasPunkc: "",
        factAddrStreet: "",
        factAddrDomOficeKvartira: "",
        factAddrOfice: "",
        factAddrKvartira: "",
        jurAddrSovpSFactich: "",
        addrForCorrespondence: "",
        otherAddrIndex: "",
        otherAddrCountry: "",
        otherAddrRegion: "",
        otherAddrRaion: "",
        otherAddrGorIliNasPunkc: "",
        otherAddrStreet: "",
        otherAddrDomOficeKvartira: "",
        otherAddrOfice: "",
        otherAddrKvartira: "",
        addrPoluchKorresp: "",
        address: "",
        finexpert: 0,
      },
      loading: false,
      rules: Globalrules,
      error: "",
      valid: true,
      orgPravForm: [
        { name: "Юридическое лицо", id: "1" },
        { name: "Индивидуальный предриниматель ", id: "2" },
      ],
      vidnologObl: [
        { name: "ОСН", id: 1 },
        { name: "УСН", id: 2 },
        { name: "Другая", id: 3 },
      ],
    };
  },
  mounted() {
    this.setTitle(`Добавить организацию: ${this.organisation.orgName}`);
  },
  methods: {
    OnChangeINNLupa() {
      if (this.organisation.inn != "") {
        if (this.organisation.inn.length == 12) {
          this.organisation.pravForm = "2";
        } else if (this.organisation.inn.length == 12) {
          this.organisation.pravForm = "1";
        }
      }

      this.loading = true;

      this.$store
        .dispatch("FillByINN", this.organisation)
        .then((res) => {
          if (res.status_api === "gosebase") {
            const data = res.data.main.data;
            this.organisation.inn = data.inn;
            this.organisation.orgName =
              data.name && data.name.full_with_opf
                ? data.name.full_with_opf
                : "";
            this.organisation.orgShortName =
              data.name && data.name.short_with_opf
                ? data.name.short_with_opf
                : "";
            this.organisation.kpp = data.kpp;
            this.organisation.ogrn = data.ogrn;
            this.organisation.jurrAddr =
              data.address && data.address.unrestricted_value
                ? data.address.unrestricted_value
                : "";
            this.organisation.okato = data.okato;
            this.organisation.oktmo = data.oktmo;
            this.organisation.address =
              data.address && data.address.unrestricted_value
                ? data.address.unrestricted_value
                : "";
            if (data.management && data.management.name) {
              let FIO = data.management.name.split(" ");
              this.organisation.directorFamil = FIO[0];
              this.organisation.directorName = FIO[1];
              this.organisation.directorOtch = FIO[2];
              this.organisation.directorDolgn =
                data.management && data.management.post
                  ? data.management.post
                  : "";
            }
          } else if (res.status_api === "dadata") {
            const data = res.data[0];
            this.organisation.inn = data.inn;
            this.organisation.orgName = data.longName;
            this.organisation.orgShortName = data.name;
            this.organisation.kpp = data.kpp;
            this.organisation.ogrn = data.ogrn;
            this.organisation.jurrAddr = data.address;
            this.organisation.okato = data.okato;
            this.organisation.oktmo = data.oktmo;
            this.organisation.address = data.address;
            if (data.directorName) {
              let FIO = data.directorName.split(" ");
              this.organisation.directorFamil = FIO[0];
              this.organisation.directorName = FIO[1];
              this.organisation.directorOtch = FIO[2];
              this.organisation.directorDolgn = data.directorDolgn;
            }
          } else {
            Swal.fire({
              icon: "warning",
              title: "ИНН в базе данных отсутствует.",
              text: "Проверьте, правильно ли вы его указали",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error;
          Swal.fire({
            icon: "error",
            title: "Что то пошло не так!",
            text: "Мы не нашли такой ИНН",
          });
        });
    },

    close() {
      this.$store.commit("SET_CURRENT_ORGANISATION_UM", {});
      if (
        this.$route.query &&
        this.$route.query.redirect === "adminpanelfinexpert"
      ) {
        this.$router.push("/adminpanelfinexpert?redirect=adminpanelfinexpert");
        return;
      }
      this.$router.push("/adminpanel?redirect=adminpanel");
    },
    save() {
      if (
        !this.organisation.inn ||
        this.organisation.inn.length < 10 ||
        this.organisation.inn.length > 12 ||
        this.organisation.inn.length == 11
      ) {
        Swal.fire({
          icon: "warning",
          title: "Внимание!",
          text: "Проверьте указанный ИНН. Он должен состоять из 10 или 12 цифр.",
        });
        return;
      }
      this.$store;
      if (
        this.$route.query &&
        this.$route.query.redirect === "adminpanelfinexpert"
      ) {
        this.organisation.finexpert = 1;
      }
      var formArr = Object.assign({}, this.organisation);
      const msg = "Организация успешно додавлена!";
      this.$store.dispatch("saveCurrentOrganisationUM", formArr).then((res) => {
        if (
          this.$store.getters.getErrorApi == "ALREADYCREATED" ||
          res.data.error === "ALREADYCREATED"
        ) {
          Swal.fire({
            icon: "warning",
            title:
              "Организация с ИНН " + this.organisation.inn + " уже существует.",
            text: "Повторная регистрация невозможна. Обратитесь в службу поддержки.",
          });
          return;
        }
        if (this.$store.getters.getErrorApi == "OK") {
          if (this.organisation.finexpert === 1) {
            var data = {
              email: this.organisation.directorEmail,
              famil: this.organisation.directorFamil,
              name: this.organisation.directorName,
              otch: this.organisation.directorOtch,
              position: "",
              phone: this.organisation.directorPhone,
              phone_note: "",
              address: "",
              bio: "",
              date: "",
              emailContact: this.organisation.directorEmail,
              role: "adminFinexpert",
              firm_id: res.data.data.id,
              active: 0,
            };

            this.$store
              .dispatch("addUserOfFirm", data)
              .then(() => {
                if (this.$store.getters.getErrorApi == "EMAILNOTUNIQUE") {
                  Swal.fire({
                    icon: "error",
                    title:
                      "Организация успешно додавлена! Email не уникальный, Пользователь не унекален",
                    text:
                      "Пользователь с email " +
                      this.user.email +
                      " уже зарегистрирован в системе.",
                  });
                  this.progress = false;
                  return;
                }
                if (this.$store.getters.getErrorApi == "OK") {
                  Swal.fire({
                    icon: "success",
                    title: "Сохранено!",
                    text: `${msg} Пользователь успешно добавлен.`,
                  });
                  return;
                }
              })
              .catch((error) => {
                this.progress = false;
                Swal.fire({
                  icon: "error",
                  title: "Ошибка!",
                  text: "Пользователь не добавлен.",
                });
                return;
              });
          }
        }
        Swal.fire({
          icon: "success",
          title: "Сохранено!",
          text: msg,
        });
        this.progress = false;
        this.$store.commit("SET_CURRENT_ORGANISATION_UM", {});
        this.$router.push(`/${this.$route.query.redirect}`);
      });
    },
  },
};
</script>

<style lang="scss"></style>
